import { useState } from 'react'
import PropTypes from 'prop-types'
import { noop, map, find } from 'lodash-es'
import StateIndicator from '../StateIndicator'
import Button from '../Button'
import Popover from '../Popover'
import SwitcherOption from './SwitcherOption'

// Allows switching between a couple of options
const Switcher = props => {
  const [indicatorOpen, setIndicatorOpen] = useState(false)

  const handleChange = value => {
    const { onChange } = props
    onChange(value)
  }
  const handlePopoverOpen = () => {
    setIndicatorOpen(true)
  }
  const handlePopoverDismiss = () => {
    setIndicatorOpen(false)
  }

  const getPopoverContent = () => {
    const { options, value } = props
    const listItems = map(options, option => {
      const optionValue = option.value
      const isCurrent = optionValue === value
      return (
        <SwitcherOption
          key={optionValue}
          label={option.label}
          description={option.description}
          value={optionValue}
          isCurrent={isCurrent}
          onClick={handleChange}
        />
      )
    })
    return <ul className="unstyled-list">{listItems}</ul>
  }

  const getLabelText = () => {
    const { options, value } = props
    const currentOption = find(options, option => option.value === value)
    return currentOption.label
  }

  const popoverContent = getPopoverContent()
  const labelText = getLabelText()
  return (
    <Popover placement="bottom-start" onOpen={handlePopoverOpen} onDismiss={handlePopoverDismiss}>
      <Popover.Reference>
        <Button className="button-reset">
          <span>{labelText}</span>
          <StateIndicator isOpen={indicatorOpen} />
        </Button>
      </Popover.Reference>
      <Popover.Content className="popover popover--menu">{popoverContent}</Popover.Content>
    </Popover>
  )
}
Switcher.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

Switcher.defaultProps = {
  options: [],
  onChange: noop,
}

export default Switcher
